var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMlbb = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 300 300",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M291.995 253.221c0-1.729.011-3.28-.001-4.831-.189-24.012-.329-48.023-.591-72.033-.195-17.808-.424-35.62-.887-53.423-.242-9.325-4.474-17.104-10.895-23.648-5.799-5.911-11.89-11.537-17.786-17.354-20.427-20.15-40.82-40.338-61.239-60.498-9.956-9.829-21.654-15.136-35.9-15.136h-.356c-40.411.251-80.823.146-121.236.2-.906.002-1.813.215-3.485.425 36.184 37.65 73.41 73.173 110.291 108.835l55.539-54.821c.9.401 1.318.468 1.56.71 12.834 12.877 25.675 25.749 38.431 38.702.863.876 1.426 2.354 1.54 3.605.325 3.565.438 7.157.473 10.739.304 31.557.59 63.115.821 94.671.018 2.438.465 4.372 2.919 5.445.773.335 1.455.953 2.073 1.552 10.189 9.845 20.34 19.728 30.547 29.552 2.503 2.405 5.176 4.632 8.182 7.308Z",
  fill: "url(#mlbb_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M289.744 70.422c1.299-4.069.909-61.624-.268-63.952h-62.659c-.232.4-.468.8-.7 1.199 21.158 20.87 42.319 41.735 63.627 62.753Z",
  fill: "url(#mlbb_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M223.106 293.453c15.222.098 30.445.019 46.422.019-1.809-1.761-3.436-3.287-5.001-4.878-8.842-8.986-17.695-17.962-26.496-26.99-9.842-10.096-19.617-20.259-29.459-30.353-1.826-1.874-2.627-3.885-2.646-6.601-.237-31.433-.608-62.866-.957-94.299-.012-1.036-.165-2.069-.32-3.899-1.374 1.218-2.176 1.897-2.943 2.614-16.064 15.04-32.133 30.078-48.176 45.144-1.298 1.217-2.48 1.516-3.864.232-.908-.842-1.895-1.602-2.777-2.466-13.694-13.428-27.365-26.875-41.066-40.294-2.859-2.801-5.813-5.506-8.723-8.254l-1.118.502c.008 37.872 1.602 75.739 1.652 113.682-1.186-.413-1.9-.867-2.496-1.444-4.177-4.046-8.361-8.085-12.482-12.187-8.772-8.735-17.538-17.474-26.205-26.307-.929-.95-1.635-2.536-1.683-3.855-.259-7.039-.28-14.084-.377-21.128-.404-29.446-.837-58.891-1.15-88.34-.026-2.446-.739-4.18-2.484-5.83-12.49-11.815-24.916-23.701-37.37-35.557-1.456-1.386-2.965-2.719-4.45-4.073l-.924.6c0 1.932-.03 3.868.002 5.8.715 40.833 1.308 81.666 2.269 122.493.187 7.98 1.898 15.792 6.046 23.024 4.33 7.554 10.566 13.327 16.592 19.262 16.706 16.464 33.558 32.787 50.63 48.871 8.94 8.424 18.398 16.306 27.75 24.283 5.115 4.363 11.38 6.952 17.765 8.295 6.087 1.278 12.518 1.139 18.803 1.221 25.079.328 50.156.55 75.236.713Z",
  fill: "url(#mlbb_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.289 293.026c-22.005-21.432-44.01-42.864-66.012-64.296-.3.178-.596.359-.894.538.593 20.968 1.186 41.936 1.795 63.416 1.496.259 3.006.744 4.518.749 16.834.057 33.67.041 50.505.026.98 0 1.96-.235 2.94-.219 1.636.029 3.27.166 4.906.271.626.04 1.248.125 1.872.191l.37-.676Z",
  fill: "url(#mlbb_svg__d)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mlbb_svg__a",
  x1: -18.607,
  y1: 262.139,
  x2: 254.621,
  y2: 41.403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA9258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.987,
  stopColor: "#E4C482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4C482"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mlbb_svg__b",
  x1: -18.607,
  y1: 262.139,
  x2: 254.621,
  y2: 41.403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA9258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.987,
  stopColor: "#E4C482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4C482"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mlbb_svg__c",
  x1: -18.607,
  y1: 262.139,
  x2: 254.621,
  y2: 41.403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA9258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.987,
  stopColor: "#E4C482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4C482"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mlbb_svg__d",
  x1: -18.607,
  y1: 262.139,
  x2: 254.621,
  y2: 41.403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA9258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.987,
  stopColor: "#E4C482"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4C482"
})))));
export default SvgMlbb;